import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, TextField, Grid, Typography, Checkbox, FormControlLabel, Paper, Link, CircularProgress } from '@mui/material';
import Cookies from 'js-cookie';
import { API } from '../controller/api';
import logo from '../assets/images/aiforhrhub.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const navigate = useNavigate();

  const handleLogin = async () => {
    setIsLoading(true); // Start loading
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password, keepLoggedIn });
      const { token, user } = response.data;

      // Set the token and user data in cookies
      Cookies.set('token', token, { expires: keepLoggedIn ? 7 : 1 });
      Cookies.set('user', JSON.stringify(user), { expires: keepLoggedIn ? 7 : 1 });

      alert(`Login Successful. Welcome back, ${user.firstName} ${user.lastName}!`);
      navigate('/');
    } catch (error) {
      alert('Login Failed. Invalid credentials');
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <Grid 
      container 
      spacing={0} 
      direction="column" 
      alignItems="center" 
      justifyContent="center" 
      style={{
        minHeight: '100vh',
        backgroundColor: '#074B79', // Deep Navy for background
        backgroundImage: 'url("https://www.transparenttextures.com/patterns/always-grey.png")', // Background texture
        backgroundSize: 'repeat',
      }}
    >
      <Grid item xs={12}>
        <Paper 
          elevation={3} 
          style={{ 
            padding: '2rem', 
            textAlign: 'center',
            maxWidth:350,
            backgroundColor: 'white', // Light Grey for Paper background
          }}
        >
          <img 
            src={logo} // Logo placeholder
            alt="Logo"
            style={{ marginBottom: '1rem', width:200 }}
          />
      
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputLabelProps={{
              style: { color: '#3A3A3A' } // Charcoal Grey for label
            }}
            InputProps={{
              style: { 
                color: '#3A3A3A', // Charcoal Grey for input text
                borderColor: '#0077B6', // Electric Blue for border on focus
              }
            }}
          />
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            margin="normal"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputLabelProps={{
              style: { color: '#3A3A3A' } // Charcoal Grey for label
            }}
            InputProps={{
              style: { 
                color: '#3A3A3A', // Charcoal Grey for input text
                borderColor: '#0077B6', // Electric Blue for border on focus
              }
            }}
          />
          <FormControlLabel
            control={<Checkbox checked={keepLoggedIn} onChange={() => setKeepLoggedIn(!keepLoggedIn)} />}
            label="Keep me logged in"
            style={{ 
              display: 'block', 
              textAlign: 'left', 
              marginBottom: '1rem', 
              color: '#3A3A3A' // Charcoal Grey for label text
            }}
          />
          <Button 
            variant="contained" 
            fullWidth 
            onClick={handleLogin}
            disabled={isLoading} // Disable button while loading
            style={{ 
              backgroundColor: '#0077B6', // Electric Blue for action button
              color: 'white' // White for button text
            }}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: 'white' }} /> // Spinner
            ) : (
              'Login'
            )}
          </Button>
          <Link 
            href="/#/forgot-password" 
            variant="body2" 
            style={{ 
              marginTop: '1rem', 
              display: 'block', 
              color: '#0077B6' // Electric Blue for forgot password link
            }}
          >
            Forgot Password?
          </Link>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Login;
